import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TokenService } from './token.service';
import { ApiItemResponse } from '../models/api';
import { User } from '../../pages/users/models/user.model';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private baseUrl = `${environment.baseUrl}`;
  private userSubject = new Subject<User>();

  constructor(private http: HttpClient, private tokenService: TokenService) {}

  getProfile(): Observable<ApiItemResponse<User>> {
    return this.http
      .get<ApiItemResponse<User>>(`${this.baseUrl}/users/profile`)
      .pipe(
        tap((res) => {
          if (res?.data) {
            this.tokenService.setUser(res.data);

            this.setUser(res.data);
          }
        })
      );
  }

  updateProfile(payload: Partial<User>): Observable<ApiItemResponse<User>> {
    return this.http
      .patch<ApiItemResponse<User>>(`${this.baseUrl}/users/profile`, payload)
      .pipe(
        tap((res) => {
          if (res?.data) {
            this.tokenService.setUser(res.data);
            this.setUser(res.data);
          }
        })
      );
  }

  resetPassword(payload: { old: string; password: string }): Observable<ApiItemResponse<any>> {
    return this.http.patch<ApiItemResponse<any>>(
      `${this.baseUrl}/users/resetPassword`,
      payload
    );
  }

  setUser(user: User): void {
    this.userSubject.next(user);
  }

  getUser(): Observable<User> {
    return this.userSubject.asObservable();
  }
}
